import classes from "./LoadingSpinner.module.scss";

interface LoadingSpinnerProps {
  fullPage?: boolean;
}

const LoadingSpinner = ({ fullPage = false }: LoadingSpinnerProps) => {
  return (
    <div
      className={`${classes.spinner__wrapper} ${
        fullPage ? classes.spinner__wrapper__fullPage : ""
      }`}
    >
      <div className={classes.spinner}></div>
    </div>
  );
};

export default LoadingSpinner;
